var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / MY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-MY",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,18.6666667 L28,20 L0,20 L0,18.6666667 L28,18.6666667 Z M28,16 L28,17.3333333 L0,17.3333333 L0,16 L28,16 Z M28,13.3333333 L28,14.6666667 L0,14.6666667 L0,13.3333333 L28,13.3333333 Z M28,10.6666667 L28,12 L0,12 L0,10.6666667 L28,10.6666667 Z M28,8 L28,9.33333333 L13.3333333,9.33333333 L13.3333333,8 L28,8 Z M28,5.33333333 L28,6.66666667 L13.3333333,6.66666667 L13.3333333,5.33333333 L28,5.33333333 Z M28,2.66666667 L28,4 L13.3333333,4 L13.3333333,2.66666667 L28,2.66666667 Z M28,0 L28,1.33333333 L13.3333333,1.33333333 L13.3333333,0 L28,0 Z",
    id: "Rectangle-537",
    fill: "#E1244A",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-1568",
    fill: "#0C3F8E",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 10.6666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66666667,1.33333333 C7.61178022,1.33333333 8.48033641,1.66111433 9.16485679,2.20919786 C8.80218128,2.07392284 8.40972344,2 8,2 C6.15905083,2 4.66666667,3.49238417 4.66666667,5.33333333 C4.66666667,7.1742825 6.15905083,8.66666667 8,8.66666667 C8.40972344,8.66666667 8.80218128,8.59274382 9.16476382,8.45750783 C8.48033641,9.00555234 7.61178022,9.33333333 6.66666667,9.33333333 C4.45752767,9.33333333 2.66666667,7.54247233 2.66666667,5.33333333 C2.66666667,3.12419433 4.45752767,1.33333333 6.66666667,1.33333333 Z M10.6666667,2.66666667 L11.1410462,4.34827405 L12.7515506,3.67069386 L11.7325878,5.09004378 L13.2664744,5.92672249 L11.5214691,6.01501551 L11.82369,7.73591698 L10.6666667,6.42666666 L9.50964336,7.73591698 L9.81186425,6.01501551 L8.0668589,5.92672249 L9.60074549,5.09004378 L8.58178271,3.67069386 L10.1922871,4.34827405 L10.6666667,2.66666667 Z",
    id: "Oval-12",
    fill: "#FFD34F",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMy);
export default __webpack_public_path__ + "static/media/MY.9f425f0ea2a86dd923d4a5966a100abf.svg";
export { ForwardRef as ReactComponent };